<template>
    <div>
        您要访问的页面出去旅行了。。。
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        }
    }
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/notFound.vue